<template>
  <div style="position:relative" v-loading="loading">
    <ContentHeader :showBack="true" />
    <div class="content-container">
      <div class="search-row">
        <el-input v-model="queryParams.themeName" placeholder="活动名称" clearable></el-input>
        <el-select v-model="queryParams.channelCode" clearable placeholder="选择渠道">
          <el-option label="CR餐饮" value="CR"></el-option>
          <el-option label="TT传统渠道" value="TT"></el-option>
          <el-option label="KBKC" value="KBKC"></el-option>
          <el-option label="NL夜店" value="NL"></el-option>
        </el-select>
        <el-select v-model="queryParams.orgCode" clearable placeholder="选择区域">
          <el-option :label="item.orgName" :value="item.orgCode" v-for="item in regionOrgList" :key="item.orgId"></el-option>
        </el-select>
        <el-button class="btn-red" size="small" @click="handleSearch">搜索</el-button>
        <el-button class="btn-reset" size="small" @click="handleReset">重置</el-button>
      </div>
      <div class="content-list" v-if="configList && configList.length">
        <el-table :data="configList" @row-click="toDetail" :row-style="{'cursor': 'pointer'}">
          <el-table-column prop="privateThemeName" label="活动名称" align="center" width="170px">
            <template #default="scope">
              <div style="font-size:16px;font-weight:700">{{scope.row.privateThemeName}}</div>
              <div style="font-size:12px;color:#bfbfbf">{{scope.row.themeName}}</div>
              <div style="font-size:12px;color:#C8102D;font-weight:700" v-if="scope.row.publishStatus === 0">已禁用</div>
            </template>
          </el-table-column>
          <el-table-column prop="channelName" label="渠道" align="center" width="80px" />
          <el-table-column prop="orgName" label="区域" align="center" />
          <el-table-column prop="date" label="活动时间" align="center">
            <template #default="scope">
              <div>{{scope.row.startDate | parseTime('{y}-{m}-{d}')}}</div>至
              <div>{{scope.row.endDate | parseTime('{y}-{m}-{d}')}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="执行周数" align="center">
            <template #default="scope">
              <div v-if="scope.row.execWeekChooseType === '01'">
                <span class="exec-week">{{scope.row.execWeekMin}}-{{scope.row.execWeekMax}}</span>
              </div>
              <div v-else>{{scope.row.execWeekScope}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="执行任务" align="center">
            <template #default="scope">
              <div v-for="item in scope.row.taskTypeScopeList" :key="item">{{item}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="费用返还方式" align="center" width="180px">
            <template #default="scope">
              <div v-for=" item in getBonusList(scope.row)" :key="item.key">{{item.key + ', ' + item.value}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="可用预算" align="center">
            <template #default="scope">
              <div v-if="scope.row.tradeBudgetTypeDTO">
                <div>{{scope.row.tradeBudgetTypeDTO.tradeBudgetInfoCountDTO.typeName}}</div>
                <div>{{scope.row.tradeBudgetTypeDTO.trCodeName}}</div>
                <div>{{scope.row.tradeBudgetTypeDTO.tradeBudgetInfoCountDTO.availableAmount | thousandSymbol}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="活动状态" align="center" width="80px">
            <template #default="scope">
              <div>{{scope.row.themeStatusName}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="nothing" v-else>当前暂无活动数据!</div>
      <div class="pag-row" v-if="total">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="queryParams.page"
          :page-size="queryParams.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          v-if="pageShow"
        />
      </div>
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
import ContentHeader from '@/components/content-header'
export default {
  components: {
    ContentHeader
  },
  data () {
    return {
      loading: false,
      total: 1,
      configList: [],
      queryParams: {
        themeName: '',
        channelCode: '',
        orgCode: '',
        page: 1,
        pageSize: 5
      },
      pageShow: true,
      regionOrgList: []
    }
  },
  mounted () {
    this.getRegionConfigList()
    this.getRegionOrgList()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name === 'perfect-region-detail') {
        vm.queryParams = JSON.parse(sessionStorage.getItem('regionListSearchForm')) ?? vm.queryParams
      }
    })
  },
  methods: {
    // 获取活动配置列表
    getRegionConfigList () {
      this.loading = true
      tradeApi.getPerfectHistoryList(this.queryParams).then(res => {
        if (res.data.resultCode === '0') {
          this.loading = false
          this.pageShow = false
          this.configList = res.data.resultData.tradePerfectThemeDefineList
          this.total = res.data.resultData.pageInfo.totalCounts
          this.$nextTick(() => {
            this.pageShow = true
          })
        }
      })
    },
    // 搜索
    handleSearch () {
      this.queryParams.page = 1
      this.getRegionConfigList()
    },
    // 重置
    handleReset () {
      // this.queryParams = this.$options.data().queryParams
      this.queryParams.themeName = ''
      this.queryParams.channelCode = ''
      this.queryParams.orgCode = ''
      this.queryParams.page = 1
      this.getRegionConfigList()
    },
    // region 区域列表
    getRegionOrgList () {
      tradeApi.getRegionOrgList().then(res => {
        if (res.data.resultCode === '0') {
          this.regionOrgList = res.data.resultData.regionList
        }
      })
    },
    // 分页器
    handleCurrentChange (val) {
      this.queryParams.page = val
      this.getRegionConfigList()
    },
    toDetail (row) {
      sessionStorage.setItem('regionListSearchForm', JSON.stringify(this.queryParams))
      this.$router.push({
        path: '/perfect/history-region',
        query: { themeDefineId: row.themeDefineId }
      })
    },
    // 返还方式数据组合
    getBonusList (data) {
      if (!data.bonusTypeNameScope) {
        return []
      }
      let list = data.bonusTypeNameScope.split(',')
      list = list.map(item => {
        item = { key: item }
        if (item.key === '线上现金返还' || item.key === '线下现金返还') {
          if (data.bonusFeeChooseType === '01') {
            item.value = data.bonusFeeMin + '-' + data.bonusFeeMax + '元/周'
          } else {
            item.value = data.bonusFeeScope + '元/周'
          }
        } else {
          if (data.bonusBeerChooseType === '01') {
            item.value = data.bonusBeerMin + '-' + data.bonusBeerMax + '箱/周'
          } else {
            item.value = data.bonusBeerQtyScope + '箱/周'
          }
        }
        return item
      })
      return list
    },
    // 预算池信息
    getBudgetInfoList (val) {
      let budgetInfo = {}
      val.budgetInfoList.forEach(item => {
        if (item.typeId === val.budgetTypeId) {
          budgetInfo = item
        }
      })
      return budgetInfo
    }
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  // display: flex;
  .el-input {
    width: 170px;
    margin-right: 20px;
  }
  .el-select {
    width: 170px;
    margin-right: 20px;
  }
  .el-switch {
    line-height: 36px;
    margin: 0 10px 0 20px;
  }
}
.handle-box {
  position: absolute;
  right: 0;
  top: 0;
}
.btn-reset {
  background-color: #bbb;
  color: #ffffff;
}
.content-list {
  ::v-deep .el-table .cell {
    line-height: 19px;
    font-size: 14px;
  }
  margin-top: 30px;
  .el-dropdown-link {
    color: #409dfe;
    cursor: pointer;
  }
}
.dropdown {
  width: 100%;
  height: 60px;
  span {
    display: block;
    height: 100%;
    width: 100%;
    line-height: 60px;
  }
}
.el-dropdown-menu__item {
  padding: 0;
  div {
    width: 70px;
    text-align: center;
  }
}
.edit-week {
  margin-left: 10px;
  font-size: 18px;
  color: #64d795 !important;
  cursor: pointer;
  .el-icon-edit::before {
    color: #64d795;
  }
}
.exec-week {
  margin-right: 5px;
}
.handle {
  width: 300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
}
.input-box {
  display: flex;
  flex-wrap: wrap;
  // flex-basis: 60%;
  margin: 0 auto;
  span {
    font-size: 16px;
    font-weight: 700;
    margin-left: 15px;
  }
  .el-input {
    width: 80px;
    height: 30px;
    line-height: 30px;
    margin-right: 25px;
  }
  .el-input-number--mini {
    width: 80px;
    margin-left: 20px;
    margin-right: 10px;
  }
  &::v-deep .el-input__inner {
    width: 80px;
    padding: 0;
  }
  &::v-deep .el-input-number__decrease,
  &::v-deep .el-input-number__increase {
    display: none;
  }
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.chooseType {
  flex-basis: 30%;
  width: 125px;
  height: 20px;
  line-height: 20px;
  margin-left: 30px;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
  color: #56b0ff;
  background-color: #eef6fd;
  border: 1px dashed #56b0ff;
  cursor: pointer;
  flex: 0 1 auto;
  flex: 0 0 auto;
  box-sizing: content-box;
}
.add-btn {
  color: #64d795;
  cursor: pointer;
  line-height: 28px;
}
.range-mode,
.fixed-mode {
  margin-bottom: 20px;
}
.fixed-mode {
  position: relative;
  .delete-btn {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0px;
    top: -9px;
    color: rgb(234, 84, 4);
    font-size: 16px;
    line-height: 20px;
    cursor: pointer;
    z-index: 999;
    text-align: center;
  }
}
.nothing {
  // background-color: #fff;
  text-align: center;
  margin-top: 20px;
  padding: 120px 0;
}
.checkbox-info {
  display: flex;
  // flex-basis: 80%;
  flex-wrap: wrap;
  // padding: 10px 0;
  &::v-deep .el-checkbox-button__inner {
    height: 30px;
    padding: 7px 15px;
    border-radius: 4px;
    margin-right: 25px;
  }
  .checkbox-wrapper {
    position: relative;
    margin-bottom: 20px;
  }
}
.row-pop-menu {
  margin-top: -10px;
}
</style>
